export default __webpack_public_path__ + "static/media/logo.86447853.png";